import { createUseStyles } from 'react-jss'
import hexToRgba from '../../helpers/hex-to-rgba'

const useStyles = createUseStyles((theme) => ({
  '@keyframes cartItemLoading': {
    from: {
      transform: 'translateX(-100%)',
    },
    to: {
      transform: 'translateX(100%)',
    },
  },
  loadingBlock: {
    display: 'block',
    backgroundColor: theme.colors.light,
    overflow: 'hidden',
    textIndent: '-9999em',
    borderRadius: 'var(--ui-radius-m)',
  },
  detailTextLoading: {
    marginBottom: 'var(--ui-spacer-xs)',
  },
  containerLoading: {
    position: 'relative',
    pointerEvents: 'none',
    '&::after': {
      content: '""',
      display: 'block',
      opacity: 0.5,
      position: 'absolute',
      left: '25%',
      top: 0,
      right: '25%',
      bottom: 0,
      background: `linear-gradient(to right, ${hexToRgba(theme.colors.background, 0)} 0%,${hexToRgba(theme.colors.background, 1)} 50%,${hexToRgba(theme.colors.background, 0)} 100%)`,
      transform: 'translateX(-100%)',
      animationName: '$cartItemLoading',
      animationDuration: '1s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-m)',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  container: {},
  thumbnail: {
    flex: '0 0 6.4rem',
  },
  thumbnailImage: {
    aspectRatio: 'var(--pages-cart-item-thumbnail-aspect-ratio)',
    borderRadius: 'var(--pages-cart-item-thumbnail-border-radius)',
    overflow: 'hidden',
    objectFit: 'cover',
    objectPosition: 'center center',
    width: '100%',
    margin: 0,
    display: 'block',
  },
  thumbnailImagePlaceholder: {
    objectFit: 'contain',
  },
  body: {
    flex: '1 1 100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 'var(--ui-spacer-s)',
  },
  contentContainer: {
    flex: '1 1 100%',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  content: {
    flex: '1 1 50%',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-xs)',
  },
  info: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-xs)',
  },
  controls: {
    alignItems: 'flex-end',
  },
  classStateLabels: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-s)',
    margin: 0,
  },
  errors: {
    '&:empty': {
      display: 'none',
    },
    borderRadius: 'var(--ui-radius-m)',
  },
  errorMessage: {
    color: 'var(--ui-color-danger)',
    fontSize: '1.2rem',
    textAlign: 'left',
    lineHeight: 1.12,
    margin: '0.5rem 0',
  },
  text: {
    textAlign: 'left',
    fontSize: '1.4rem',
    lineHeight: 1.25,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'var(--ui-spacer-m)',
    marginTop: '-0.2rem',
  },
  title: {
    extend: 'text',
    marginTop: 0,
    marginBottom: 0,
    flex: 1,
  },
  titleLink: {
    color: 'currentColor',
    textDecoration: 'none',
  },
  quantity: {
    display: 'flex',
    flexBasis: '10rem',
    justifyContent: 'flex-end',
    flexShrink: 0,
    flexGrow: 0,
  },
  variant: {
    extend: 'text',
    color: 'var(--ui-color-aux)',
    '& span': {
      color: 'currentColor',
      font: 'inherit',
      lineHeight: 'inherit',
    },
  },
  variantPrice: {
    flexShrink: 0,
  },
  skuQuotaInfo: {
    extend: 'text',
    color: 'var(--ui-color-aux)',
  },
  addons: {
    extend: 'text',
    color: 'var(--ui-color-aux)',
  },
  addonsItem: {
    marginBottom: 0,
    fontSize: 'inherit',
    lineHeight: 'inherit',
  },
  discounts: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 'var(--ui-spacer-s)',
  },
  amount: {
    extend: 'text',
    margin: 0,
    '& span': {
      color: 'currentColor',
      font: 'inherit',
      lineHeight: 'inherit',
    },
  },
  unitPrice: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  subtotalAmount: {
    fontWeight: '600',
  },
  actions: {
    extend: 'text',
  },
  actionLink: {
    color: 'inherit',
    paddingRight: '1rem',
    textDecoration: 'underline',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-s)',
  },
  button: {
    width: 'auto',
  },
  buttonRemove: {
    color: 'var(--ui-color-danger)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-xs)',
    fontSize: '1.2rem',
    fontWeight: 600,
  },
  buttonRemoveIcon: {
    width: '1em',
    marginLeft: 0,
  },
}))

export default useStyles
